import { getTypeObject, TYPES } from "../constants/accounting";

export const codeIsEmpty = code => {
  return code === undefined || code === null || code === "";
};
export const eliminateLastEmptyFields = array => {
  let result = [...array];
  while (true) {
    result = result.filter((obj, index) => {
      return !(index === result.length - 1 && codeIsEmpty(obj.code));
    });
    if (result.length <= 0 || !codeIsEmpty(result[result.length - 1].code)) {
      break;
    }
  }
  return result;
};

export const getAccountingCodesAsString = accountingCodes => {
  let result = "";
  accountingCodes.forEach((accountingCode, index) => {
    const type = accountingCode.type;
    if (type === TYPES.CONSTANT) {
      result += `<span>${accountingCode.code}</span>`;
    } else {
      const typeRow = getTypeObject(type);
      result += `<span>${typeRow.value}</span>`;
    }
    if (index !== accountingCodes.length - 1) {
      result += `<span>&nbsp;-&nbsp;</span>`;
    }
  });
  return result;
};
